
/*
Defines the custom element <ravel-led>
*/

import { RavelLed } from './src/RavelLed.js';

customElements.define('ravel-led', RavelLed);
